let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hP6AB")).then(() => parcelRequire('59FhQ'));